import xss from 'xss';

const ProductBrand = ({ brand, brandDescription }) => {
  return brand && brandDescription ? (
    <>
      <h2 className="font-frl fs-15 fs-xxl-18 fw-900 mb-10 mb-sm-15 text-primary lh-1">
        About {brand}
      </h2>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: xss(brandDescription) }}
        className="font-roboto fs-7 fs-md-8 fw-400 mb-14 mb-xl-25 lh-3"
      />
    </>
  ) : null;
};

export default ProductBrand;
